import BaseService from './BaseService'
import ConfigService from './ConfigService'

export default new (class CartService extends BaseService {
  constructor() {
    super({
      baseURL: () => ConfigService.get('api.cart') + '/shop/' + ConfigService.get('shop.current')
    })
  }

  addArticle({ id = '', amount = 1, properties = {} }) {
    return this.post('/article/add', {
      id,
      amount,
      properties,
      currentUrl: location.href
    }).then(result => {
      this.emit('articleAdded', id)
      return result
    })
  }

  addBundle({ id = '', amount = 1, properties = {} }) {
    return this.post('/bundle/add', {
      id,
      amount,
      properties,
      currentUrl: location.href
    }).then(result => {
      this.emit('bundleAdded', id)
      return result
    })
  }

  addBundleWithParams({ id = '', amount = 1, properties = {} }) {
    return this.post('/bundle/addWithParams', {
      id,
      amount,
      properties,
      currentUrl: location.href
    }).then(result => {
      this.emit('bundleAdded', id)
      return result
    })
  }

  async addItems(items = []) {
    const results = []
    for (const { type, id, amount, properties } of items) {
      if (type === 'bundle') {
        const result = await this.addBundle({ id, amount, properties })
        results.push(result)
      } else if (type === 'bundleWithParams') {
        const result = await this.addBundleWithParams({ id, amount, properties })
        results.push(result)
      } else {
        const result = await this.addArticle({ id, amount, properties })
        results.push(result)
      }
    }
    return results
  }
})()
